import { useState, useEffect } from "react";

const FAQItem = ({ question, answer, isOpen, toggleOpen }) => {
  return (
    <div className="border-b border-gray-200 py-4">
      <button
        className="flex justify-between items-center w-full text-left focus:outline-none"
        onClick={toggleOpen}
        aria-expanded={isOpen}
      >
        <h3 className="text-lg font-medium text-gray-900">{question}</h3>
        <span className="ml-6 flex-shrink-0">
          <svg
            className={`w-6 h-6 transition-transform duration-300 ${
              isOpen ? "transform rotate-180" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </span>
      </button>
      <div
        className={`mt-2 transition-all duration-300 overflow-hidden ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div
          className="text-base text-gray-700"
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      </div>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqItems = [
    {
      question: "Как забронировать фотосессию в Лесной Усадьбе?",
      answer:
        "Для бронирования фотосессии свяжитесь с нами через Telegram или по телефону. Мы обсудим детали, выберем удобную дату и время, а также подберем подходящие локации для вашей фотосессии в нашей усадьбе Подмосковья.",
    },
    {
      question: "Какие фотозоны доступны в Лесной Усадьбе?",
      answer:
        "В нашей усадьбе представлены разнообразные фотозоны: уютный дом с винтажным интерьером, сад, поляна, пикник, костер, мольберт, грядка, столик и другие локации. Каждая зона имеет свое уникальное настроение и атмосферу.",
    },
    {
      question: "Где находится Лесная Усадьба?",
      answer:
        "Лесная Усадьба расположена Московской области, примерно в часе езды от Москвы. После бронирования мы отправим вам точный адрес и схему проезда.",
    },
    {
      question: "Можно ли приехать со своим фотографом?",
      answer:
        "Да, вы можете приехать со своим фотографом. Мы предоставляем локацию для съемки, а вы можете выбрать любого фотографа по вашему желанию.",
    },
    {
      question: "Какое время года лучше для фотосессии в Подмосковье?",
      answer:
        "Лесная Усадьба Подмосковья прекрасна в любое время года. Весной вас ждет цветущий сад, летом — пышная зелень и яркие цветы, осенью — золотая листва, а зимой — уютная атмосфера с теплым светом и возможностью съемки у камина.",
    },
    {
      question: "Как добраться до Лесной Усадьбы из Москвы?",
      answer:
        "Из Москвы до нашей фотолокации можно добраться на автомобиле по Ленинградскому шоссе (время в пути около 1 часа) или на электричке с Ленинградского вокзала до станции Подсолнечная, а затем на такси (около 15 минут).",
    },
    {
      question: "Есть ли на территории усадьбы парковка?",
      answer:
        "Да, на территории нашей фотолокации есть бесплатная парковка для гостей.",
    },
  ];

  // Создаем структурированные данные для FAQ
  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
    about: {
      "@type": "LocalBusiness",
      name: "Лесная Усадьба",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Солнечногорский район",
        addressRegion: "Московская область",
        addressCountry: "RU",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: "56.1842",
        longitude: "36.9914",
      },
    },
    keywords:
      "фотолокация, фотосессия, Подмосковье, Солнечногорский район, Московская область, FAQ, вопросы и ответы",
  };

  // Добавляем структурированные данные в head
  useEffect(() => {
    let scriptTag = document.querySelector("#faq-structured-data");
    if (!scriptTag) {
      scriptTag = document.createElement("script");
      scriptTag.id = "faq-structured-data";
      scriptTag.type = "application/ld+json";
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(faqStructuredData);

    return () => {
      if (scriptTag && document.head.contains(scriptTag)) {
        document.head.removeChild(scriptTag);
      }
    };
  }, []);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section id="faq" className="section bg-white py-16">
      <div className="container">
        <h2 className="mb-12 text-3xl font-bold text-center font-serif header-color md:text-4xl">
          Часто задаваемые вопросы о фотолокации
        </h2>

        <div className="max-w-3xl mx-auto">
          {faqItems.map((item, index) => (
            <FAQItem
              key={index}
              question={item.question}
              answer={item.answer}
              isOpen={openIndex === index}
              toggleOpen={() => toggleFAQ(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
